export default __webpack_public_path__ + "static/media/logo.131434c7.png";